module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_diamond_chestnut.72d51cd4.png";